import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import userColumns from "./userColumns";

type Props = {
  name: string;
  search: string;
};

const query = gql`
  query Currentlist($search: String, $offset: Int, $limit: Int) {
    users(search: $search, offset: $offset, limit: $limit) {
      external_reference
      email
      created_at
      snapmin_url
      group
      fraud_status
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ search, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      search,
      offset,
      limit
    }
  })
});

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={userColumns}
        defaultColumns={["Date", "Email", "Fraud status", "Group"]}
        rows={props.data.users || []}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
